<loren-error-template
  title="503 - Service Unavailable"
  [message]="'error_page.service_unavailable_message' | transloco"
  button="false"
></loren-error-template>
